import { Component } from '@angular/core';
import { DashboardChartInput } from './common-apex';
import {
  ReportDashboardsApiService,
  SelectType,
} from './report-dashboards-api.service';
import { DateSelectorOutput } from '../../common/date-selector/date-selector.component';
import { formatNumber } from '../../shared/utils/numbers';

@Component({
  selector: 'app-report-dashboards',
  templateUrl: './report-dashboards.component.html',
  styleUrls: ['./report-dashboards.component.scss'],
})
export class ReportDashboardsComponent {
  constructor(public reportDashboardApiService: ReportDashboardsApiService) {}
  periodRange: SelectType[] = [];
  selectedPeriod = '';
  ngOnInit() {
    this.reportDashboardApiService.initDashboard();
    this.selectedPeriod = this.reportDashboardApiService.defaultPeriod;
    this.periodRange = this.reportDashboardApiService.periodRange;
  }

  tripAttendanceOptions: DashboardChartInput = {
    labels: ['Actual', 'Absent'],
    title: {
      text: 'Actual vs Absent Trips',
    },
    colors: ['#50C878', '#98AFC7'],
    height: '240px',
    width: 'auto',
  };

  mileageOptions: DashboardChartInput = {
    labels: ['Actual', 'Missing'],
    title: {
      text: 'Actual vs Missing Mileage (km)',
    },
    colors: ['#50C878', '#98AFC7'],
    height: '240px',
    width: 'auto',
    plotOptions: {
      pie: {
        donut: {
          size: '75%',
          labels: {
            show: true,
            total: {
              color: '#fff',
              show: true,
              formatter: function (w) {
                let result = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                // return `${Math.round(result * 100) / 100}`; // * 100 for 2 decimal numbers
                return formatNumber(result, 'km');
              },
            },
            value: {
              offsetY: -4,
              formatter: function (value) {
                return formatNumber(value, 'km');
              },
            },
          },
        },
        expandOnClick: false,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return formatNumber(val, 'km');
        },
      },
    },
  };

  tripPerformanceOptions: DashboardChartInput = {
    title: {
      text: 'Trip Performance Per Day',
    },
    xaxis: {
      type: 'datetime',
      tickPlacement: 'on',
      labels: {
        datetimeFormatter: {
          year: 'yyyy',
          month: 'MMM yyyy',
          day: 'MMM d',
        },
      },
    },
    yaxis: {
      title: {
        text: 'Performance per Stop',
      },
    },
    chart: {
      zoom: {
        enabled: false,
      },
    },
  };

  mileageScheduleOptions: DashboardChartInput = {
    title: {
      text: 'Total Mileage Per Day',
    },
    xaxis: {
      type: 'datetime',
      tickPlacement: 'on',
      labels: {
        datetimeUTC: false,
        datetimeFormatter: {
          year: 'yyyy',
          month: 'MMM yyyy',
          day: 'MMM d',
        },
      },
    },
    yaxis: {
      title: {
        text: 'Mileage (KM)',
      },
      labels: {
        formatter: function (val) {
          // return `${Math.round(val * 100) / 100}`;
          return formatNumber(val, 'km');
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    chart: {
      zoom: {
        enabled: false,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          // return `${Math.round(val * 100) / 100} KM`;
          return formatNumber(val, 'km');
        },
      },
    },
  };

  onPeriodSelect(value: string) {
    console.log('Period change: ', value);
    this.selectedPeriod = value;
    if (value === 'latest') {
      this.reportDashboardApiService.getLatestValues();
    } else {
    }
  }

  onSearchDate(event: DateSelectorOutput) {
    console.log('Date Change', event);
    const { startDate, endDate } = event;
    // if (type === 'start') {
    //   this.startDate = event;
    // }
    // if (type === 'end') {
    //   this.endDate = event;
    // }
    // if (!!this.startDate && !!this.endDate) {
    //   console.log('Dates selected: ', this.startDate, this.endDate);
    // }
  }
}
